var map = {
	"./amex-square.svg": "86fd",
	"./diners-square.svg": "ca14",
	"./discover-square.svg": "b698",
	"./jcb-square.svg": "3a2b",
	"./maestro-square.svg": "5c5b",
	"./mastercard-square.svg": "0357",
	"./sepa_debit-square.svg": "e5c5",
	"./visa-square.svg": "c7cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1694";